<template>
  <div class="bodyContent">
    <el-row style="padding-bottom: 10px">
      <el-col
        :lg="8"
        :md="9"
        :sm="24"
        :xl="8"
        :xs="24"
        style="height: 100%; width: 100%"
      >
        <div class="bg-color divPadding">
          <div style="height: 10vh; line-height: 80px">
            <span class="title-line"></span>
            <span style="padding-right: 5%">服务器概况</span>
            <span class="text-grey" style="padding-right: 1%"
              >操作系统版本：</span
            >
            <span style="padding-right: 2%">{{ resultData.systemName }}</span>
            <span class="text-grey" style="padding-right: 1%">运行时长：</span>
            <span>{{ resultData.runningTime }}小时</span>
          </div>
        </div>
      </el-col>
    </el-row>

    <div ref="printArea" style="padding-top: 5px; height: 100%">
      <!--能耗统计-->
      <el-row>
        <el-col :lg="6" :md="6" :sm="6" :xl="6" :xs="6">
          <div class="bg-color divPadding">
            <div>
              <span class="title-line"></span>
              <span>CPU使用率</span>
            </div>
            <div style="display: flex; flex-direction: column">
              <div
                style="
                  height: 28vh;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  padding-top: 8%;
                "
              >
                <el-progress
                  :percentage="resultData.cpuUsage"
                  :stroke-width="15"
                  :width="180"
                  :color="cpuColor"
                  type="circle"
                >
                </el-progress>
              </div>
              <div
                style="
                  height: 10vh;
                  display: flex;
                  flex-direction: row;
                  justify-content: center;
                "
              >
                <div
                  style="
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    justify-content: center;
                    margin-right: 30%;
                  "
                >
                  <span style="font-size: 25px"
                    >{{ resultData.cpuUsage }}%</span
                  >
                  <span class="text-grey">已使用</span>
                </div>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    justify-content: center;
                  "
                >
                  <span style="font-size: 25px">{{ unUseCpuUsage }}%</span>
                  <span class="text-grey">未使用</span>
                </div>
              </div>
              <div style="height: 40vh">
                <server-usage-chart
                  :data="cpuData"
                  :extend-data="extendData"
                  ref="cpuLineChart"
                  v-if="cpuData"
                  style="height: 95%"
                ></server-usage-chart>
                <no-data
                  style="text-align: center; margin-top: 25%"
                  v-else
                ></no-data>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :lg="6" :md="6" :sm="6" :xl="6" :xs="6" class="rightDiv">
          <div class="bg-color divPadding">
            <div>
              <span class="title-line"></span>
              <span>内存使用率</span>
            </div>
            <div style="display: flex; flex-direction: column">
              <div
                style="
                  height: 28vh;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  padding-top: 8%;
                "
              >
                <el-progress
                  :percentage="resultData.memoryUsage"
                  :stroke-width="15"
                  :width="180"
                  :color="memoryColor"
                  type="circle"
                >
                </el-progress>
              </div>

              <div
                style="
                  height: 10vh;
                  display: flex;
                  flex-direction: row;
                  justify-content: center;
                "
              >
                <div
                  style="
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    justify-content: center;
                    margin-right: 15%;
                  "
                >
                  <span style="font-size: 25px"
                    >{{ resultData.memoryTotal }}G</span
                  >
                  <span class="text-grey">总内存</span>
                </div>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    justify-content: center;
                    margin-right: 15%;
                  "
                >
                  <span style="font-size: 25px"
                    >{{ resultData.memoryBeused }}G</span
                  >
                  <span class="text-grey">已用内存</span>
                </div>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    justify-content: center;
                  "
                >
                  <span style="font-size: 25px">{{ unUseMemory }}G</span>
                  <span class="text-grey">可用内存</span>
                </div>
              </div>

              <div style="height: 40vh">
                <server-usage-chart
                  :data="memoryData"
                  :extend-data="extendData"
                  ref="memoryLineChart"
                  v-if="memoryData"
                  style="height: 95%"
                ></server-usage-chart>
                <no-data
                  style="text-align: center; margin-top: 25%"
                  v-else
                ></no-data>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :lg="6" :md="6" :sm="6" :xl="6" :xs="6" class="rightDiv">
          <div class="bg-color divPadding">
            <div>
              <span class="title-line"></span>
              <span>磁盘使用率</span>
            </div>
            <div style="display: flex; flex-direction: column">
              <div
                style="
                  height: 28vh;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  padding-top: 8%;
                "
              >
                <el-progress
                  :percentage="resultData.diskUsage"
                  :stroke-width="15"
                  :width="180"
                  :color="diskColor"
                  type="circle"
                >
                </el-progress>
              </div>
              <div
                style="
                  height: 10vh;
                  display: flex;
                  flex-direction: row;
                  justify-content: center;
                "
              >
                <div
                  style="
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    justify-content: center;
                    margin-right: 15%;
                  "
                >
                  <span style="font-size: 25px"
                    >{{ resultData.diskTotal }}G</span
                  >
                  <span class="text-grey">总容量</span>
                </div>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    justify-content: center;
                    margin-right: 15%;
                  "
                >
                  <span style="font-size: 25px"
                    >{{ resultData.diskBeused }}G</span
                  >
                  <span class="text-grey">已用容量</span>
                </div>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    justify-content: center;
                  "
                >
                  <span style="font-size: 25px">{{ unUseDisk }}G</span>
                  <span class="text-grey">可用容量</span>
                </div>
              </div>
              <div style="height: 40vh">
                <server-usage-chart
                  :data="diskData"
                  :extend-data="extendData"
                  ref="diskLineChart"
                  v-if="diskData"
                  style="height: 95%"
                ></server-usage-chart>
                <no-data
                  style="text-align: center; margin-top: 25%"
                  v-else
                ></no-data>
              </div>
            </div>
          </div>
        </el-col>
        <el-col
          :lg="6"
          :md="6"
          :sm="6"
          :xl="6"
          :xs="6"
          class="rightDiv"
          style="height: 80vh"
        >
          <div class="bg-color divPadding">
            <div>
              <span class="title-line"></span>
              <span>网络状态</span>
            </div>
            <div style="display: flex; flex-direction: column; height: 100%">
              <!-- 根据networkStat数组长度动态渲染网络状态卡片 -->
              <template v-if="networkStatArray.length > 0">
                <div v-for="(network, index) in networkStatArray" 
                     :key="index"
                     style="height: 33.3%;">
                  <div class="capacity-card" :style="index !== networkStatArray.length - 1 ? 'border-bottom: 1px dashed rgba(255, 255, 255, 0.2)' : ''">
                    <div class="capacity-row">
                      <div class="capacity-item">
                        <div class="capacity-value">{{ network.speedMb }}</div>
                        <div class="capacity-label">速率(Mb/s)</div>
                      </div>
                      <div class="capacity-item">
                        <div class="capacity-value">{{ network.rxKBps }}</div>
                        <div class="capacity-label">↓接收(KB/s)</div>
                      </div>
                      <div class="capacity-item">
                        <div class="capacity-value">{{ network.txKBps }}</div>
                        <div class="capacity-label">↑发送(KB/s)</div>
                      </div>
                      <div class="capacity-item">
                        <div class="capacity-value">{{ network.rxUsage }}</div>
                        <div class="capacity-label">↓占用率</div>
                      </div>
                    </div>
                    <div class="capacity-row" style="margin-top: 8px;">
                      <div class="capacity-item">
                        <div class="capacity-value">{{ network.txUsage }}</div>
                        <div class="capacity-label">↑占用率</div>
                      </div>
                      <div class="capacity-item"></div>
                      <div class="capacity-item"></div>
                      <div class="capacity-item"></div>
                    </div>
                  </div>
                </div>
              </template>
              <!-- 如果没有网络数据则显示提示信息 -->
              <div v-else style="height: 100%; display: flex; align-items: center; justify-content: center; color: #909399;">
                暂无网络数据
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import ServerUsageChart from "@/components/echarts/ServerUsageChart";
import {
  getServerUsageDetail,
  getServerUsageDetailList,
} from "@/network/device-info";

export default {
  name: "ServerUsageDetails",
  components: { ServerUsageChart },
  data() {
    return {
      resultData: {},
      arrayData: {},
      cpuData: {
        time: [],
        valueArray: [],
      },
      memoryData: {
        time: [],
        valueArray: [],
      },
      diskData: {
        time: [],
        valueArray: [],
      },
      extendData: null,
      time: null,
      time1: null,
    };
  },
  mounted() {
    this.$store.dispatch("addIntervalObj", {
      "getServerUsageDetail:30000": this.getServerUsageDetail,
    });
    this.$store.dispatch("addIntervalObj", {
      "getServerUsageDetailList:30000": this.getServerUsageDetailList,
    });
  },
  created() {
    this.getServerUsageDetail();
    this.getServerUsageDetailList();
  },
  destroyed() {
    this.$store.dispatch("removeIntervalObj", "getServerUsageDetail");
    this.$store.dispatch("removeIntervalObj", "getServerUsageDetailList");
  },
  computed: {
    // 未使用cpu
    unUseCpuUsage() {
      return Number(100 - this.resultData.cpuUsage).toFixed(2);
    },
    unUseMemory() {
      return this.resultData.memoryTotal - this.resultData.memoryBeused;
    },
    unUseDisk() {
      return this.resultData.diskTotal - this.resultData.diskBeused;
    },
    cpuColor() {
      if (this.resultData.cpuUsage > 70) {
        return "#E18F01";
      } else {
        return "#12BE80";
      }
    },
    memoryColor() {
      if (this.resultData.memoryUsage > 70) {
        return "#E18F01";
      } else {
        return "#12BE80";
      }
    },
    diskColor() {
      if (this.resultData.diskUsage > 70) {
        return "#E18F01";
      } else {
        return "#12BE80";
      }
    },
    
    // 网络状态数组
    networkStatArray() {
      if (this.resultData && this.resultData.networkStat) {
        try {
          // 尝试将JSON字符串解析为数组
          return JSON.parse(this.resultData.networkStat);
        } catch (error) {
          console.error('解析网络状态数据失败:', error);
          return [];
        }
      }
      return [];
    },
  },
  methods: {
    //初始化数据
    getServerUsageDetail() {
      getServerUsageDetail().then((res) => {
        if (res.code === 0) {
          this.resultData = res.data;
        }
      });
    },
    getServerUsageDetailList() {
      getServerUsageDetailList().then((res) => {
        if (res.code === 0) {
          this.cpuData.time = res.data.timeArray;
          this.cpuData.valueArray = res.data.cpuArray;
          this.memoryData.time = res.data.timeArray;
          this.memoryData.valueArray = res.data.memoryArray;
          this.diskData.time = res.data.timeArray;
          this.diskData.valueArray = res.data.diskArray;
        }
      });
    },
  },
};
</script>

<style scoped>
.divPadding {
  padding: 10px 20px 10px 20px;
  height: 100%;
}

.title-line {
  width: 5px;
  height: 15px;
  border-left: 2px solid #299ffb;
  display: inline-block;
  margin-bottom: -2px;
  margin-right: 5px;
}

/*md以上*/
@media (min-width: 1200px) {
  .condition {
    margin-left: 22vw;
  }
}

/*md以上*/
@media (min-width: 989px) {
  .rightDiv {
    padding-left: 20px;
    margin-top: 0;
  }

  .condition {
    margin-left: 10vw;
  }
}

@media (min-width: 1920px) {
  .condition {
    margin-left: 35vw;
  }
}

@media (max-width: 989px) {
  .rightDiv {
    padding-left: 0;
    margin-top: 20px;
  }

  .condition {
    margin-left: 18vw;
  }
}
.capacity-card {
  margin: 10px 0;
  padding: 15px 5px;
  border-radius: 4px;
}

.capacity-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.capacity-item {
  width: 25%;
  text-align: center;
  margin-bottom: 30px;

}

.capacity-value {
  font-size: 18px;
  font-weight: bold;
  color: #fff;
}

.capacity-label {
  font-size: 12px;
  color: #aaa;
  margin-top: 5px;
}
</style>
